'use strict';

const _=require('pulsar-utils/dist-es6/_');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');
const moment=require('pulsar-utils/dist-es6/time/moment');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DebugToolsDirective=class DebugToolsDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/debugToolsDirective/debugToolsTemplate'}

get controller(){return DebugToolsDirectiveController}

get $inject(){return['$scope','$interval','$timeout','$mdSidenav','$mdToast','dateService','timeZoneService','socketService']}};


const AdditionalTimeZoneOptions=[
'Asia/Dubai'];let


DebugToolsDirectiveController=class DebugToolsDirectiveController{
constructor($scope,$interval,$timeout,$mdSidenav,$mdToast,dateService,timeZoneService,socketService){
this._$scope=$scope;
this._$interval=$interval;
this._$timeout=$timeout;
this._$mdToast=$mdToast;

this._dateService=dateService;
this._dateService.reset();

this._timeZoneService=timeZoneService;
this._timeZoneService.reset();

this._socketService=socketService;

this.toolsVisible=!1;

this._localTimeZone=this._timeZoneService.localTimeZone;

this.mockDate=this._dateService.currentDateString();
this.mockTimeZone=this._timeZoneService.localTimeZone;
this.availableTimeZoneOptions=_.uniq([this._timeZoneService.localTimeZone].concat(AdditionalTimeZoneOptions).concat(this._timeZoneService.USIanaTimeZones));
this.currentMockState=[this._dateService.isMocked,this._timeZoneService.isMocked].every(v=>v===!0);

this.enableDigestSpeedMonitor=!0;

this._$mdSidenav=$mdSidenav;

this._$scope.$watchGroup(['controller.mockDate','controller.mockTimeZone'],()=>{
const date=this.mockDate instanceof Date?this.mockDate:new Date(this.mockDate);
if(date.getTime()===Number.NaN){
console.error(`MockDate is not a valid date: ${this.mockDate}`);
return;
}

if(!_.exists(moment.tz(this.mockTimeZone))){
console.error(`MockTimeZone is not a valid timezone: ${this.mockTimeZone}`);
return;
}

this.updateCurrentMockState();
});

this.updateCurrentMockState();
}

updateCurrentMockState(){
const dateFromCalendar=moment(this.mockDate);
this._mockDateInTimeZone=zonedMoment(dateFromCalendar.toDate(),this.mockTimeZone).format(`YYYY-MM-DD hh:mm a z`);

if(this.currentMockState){
this.enableMockDate();
return;
}

this.resetServicesToNormal();
}

addHours(numHours){
this._$scope.$evalAsync(()=>{
this.mockDate=new Date(new Date(this.mockDate).getTime()+numHours*1000*60*60);
this.updateCurrentMockState();
});
}

get _sidebarElement(){
return this.__sidebarElement||(this.__sidebarElement=this._$mdSidenav('debug-tools'));
}

closeToolsSidebar(){
this._sidebarElement.close();
}

toggleToolsSidebar(){
this._sidebarElement.toggle();
}

get mockDateInTimeZone(){
return this._mockDateInTimeZone;
}

get useMockConnectionStatus(){
return this._socketService.useMockConnectionStatus;
}

set useMockConnectionStatus(useMockConnectionStatus){
return this._socketService.useMockConnectionStatus=useMockConnectionStatus;
}

get mockConnectionStatus(){
return this._socketService.mockConnectionStatus;
}

set mockConnectionStatus(mockConnectionStatus){
return this._socketService.mockConnectionStatus=mockConnectionStatus;
}

enableMockDate(){
this._dateService.setMockDate(this.mockDate);
this._timeZoneService.setMockTimeZone(this.mockTimeZone);
this.currentMockState=!0;
}

resetServicesToNormal(){
this._dateService.reset();
this._timeZoneService.reset();
this.currentMockState=!1;
}

logCurrentFeatureControllerToConsole(){
console.dir(angular.element('[data-ui-view="main"]').controller());
const toast=this._$mdToast.simple().textContent('Printed main controller to console').position('top right').hideDelay(1618);
this._$mdToast.show(toast);
}};


module.exports=DebugToolsDirective;
//# sourceMappingURL=debugToolsDirective.js.map
